import { NgxMonacoEditorConfig } from "ngx-monaco-editor-v2";
import { ENV_VAR_SUGGESTIONS, RUNFILE_KEY_SUGGESTIONS } from "./editor-lint";

/** Language id for XWI runfiles ('Parameter : value' lines, '!' comments). */
export const RUNFILE_LANGUAGE = "scube-runfile";

function wordRange(model: any, position: any) {
  const word = model.getWordUntilPosition(position);
  return {
    startLineNumber: position.lineNumber,
    endLineNumber: position.lineNumber,
    startColumn: word.startColumn,
    endColumn: word.endColumn,
  };
}

// Runfile keys contain spaces ('awi adjnormfilt'), so a word-based range would
// only replace the last word and duplicate the rest of the typed key. Replace
// the whole key region: first non-blank column through the cursor.
function keyRange(model: any, position: any) {
  const lineStart = model
    .getLineContent(position.lineNumber)
    .match(/^\s*/)[0].length;
  return {
    startLineNumber: position.lineNumber,
    endLineNumber: position.lineNumber,
    startColumn: lineStart + 1,
    endColumn: position.column,
  };
}

function onMonacoLoad(): void {
  const monaco = (window as any).monaco;

  monaco.languages.register({ id: RUNFILE_LANGUAGE });
  monaco.languages.setMonarchTokensProvider(RUNFILE_LANGUAGE, {
    tokenizer: {
      root: [
        [/!.*$/, "comment"],
        [/^[^!:]+(?=:)/, "type"],
      ],
    },
  });
  monaco.languages.setLanguageConfiguration(RUNFILE_LANGUAGE, {
    comments: { lineComment: "!" },
  });

  monaco.languages.registerCompletionItemProvider(RUNFILE_LANGUAGE, {
    provideCompletionItems: (model: any, position: any) => {
      const range = keyRange(model, position);
      return {
        suggestions: RUNFILE_KEY_SUGGESTIONS.map((key) => ({
          label: key,
          kind: monaco.languages.CompletionItemKind.Property,
          insertText: key,
          range,
        })),
      };
    },
  });

  // env.sh editors use the stock 'shell' language; offer the XWI variables there.
  monaco.languages.registerCompletionItemProvider("shell", {
    provideCompletionItems: (model: any, position: any) => {
      const range = wordRange(model, position);
      return {
        suggestions: ENV_VAR_SUGGESTIONS.map((name) => ({
          label: name,
          kind: monaco.languages.CompletionItemKind.Variable,
          insertText: name,
          range,
        })),
      };
    },
  });
}

export const monacoConfig: NgxMonacoEditorConfig = { onMonacoLoad };
